import React from "react";
import useStyles from "./styles";
import { Link, Typography } from "@mui/material";
import CustomButton from "../common/button/CustomButton";

// Define the props interface
interface PageTitleProps {
  title: string;
  subtitle?: string;
  urlLink?: string;
  button1?: string;
  button?: any;
  search?: boolean;
  editIcon?: boolean;
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "subtitle1"
    | "subtitle2"
    | "body1"
    | "body2";
  onClickDownload?: () => void;
  onClick?: () => void;
  onClick1?: () => void;
  btnDisabled?: boolean;
}

const PageTitle: React.FC<PageTitleProps> = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.pageTitleContainer}>
      <Typography sx={{textTransform:'capitalize !important'}}
        variant={props?.variant ? props?.variant : "h5"}
        fontWeight={700}
      >
        {props.urlLink ? (
          <Link href={props.urlLink} underline="none">
            {props.subtitle}{" "}
          </Link>
        ) : (
          <>{props.subtitle} </>
        )}
        {props.title}
      </Typography>
      <div>
        {props.button && (
          <CustomButton title={props.button} onClick={props.onClick} disabled={props?.btnDisabled} />
        )}
        {props.button1 && (
          <CustomButton style={{marginLeft:'8px'}} title={props.button1} onClick={props.onClick1} />
        )}
      </div>
      
    </div>
  );
};

export default PageTitle;
